var map = {
	"./7z.svg": "4cc4",
	"./aac.svg": "6e694",
	"./ai.svg": "942e",
	"./archive.svg": "7016",
	"./arj.svg": "12ad",
	"./audio.svg": "7bc4",
	"./avi.svg": "a991",
	"./battery-charging.svg": "598a6",
	"./battery-full.svg": "65ee",
	"./battery-warning.svg": "ee6f",
	"./circle.svg": "a32c",
	"./css.svg": "6a79",
	"./csv.svg": "d849",
	"./dbf.svg": "2fc0",
	"./doc.svg": "84b6",
	"./dwg.svg": "2035",
	"./exe.svg": "7ed8",
	"./file-plus.svg": "1e59",
	"./fla.svg": "f15e",
	"./flac.svg": "d3fa",
	"./gif.svg": "1202",
	"./gps_off.svg": "e9ce",
	"./gps_on.svg": "6d5e",
	"./html.svg": "0f08",
	"./image.svg": "34bf",
	"./iso.svg": "78a2",
	"./jpg.svg": "1365",
	"./js.svg": "b65e",
	"./json.svg": "8d1a",
	"./mdf.svg": "a752",
	"./message-square.svg": "f04c",
	"./mp2.svg": "b614",
	"./mp3.svg": "2cea",
	"./mp4.svg": "e67c",
	"./mxf.svg": "5a2f",
	"./nrg.svg": "343c",
	"./pdf.svg": "f03b",
	"./png.svg": "eea7",
	"./ppt.svg": "dc3f",
	"./psd.svg": "ba80",
	"./rar.svg": "4457",
	"./rtf.svg": "776e",
	"./svg.svg": "f672",
	"./text.svg": "9ff7",
	"./tiff.svg": "8204",
	"./txt.svg": "bf80",
	"./unknown.svg": "ffb5",
	"./video.svg": "efb5",
	"./wav.svg": "bf65",
	"./wma.svg": "fe91",
	"./xls.svg": "0a0b",
	"./xlsx.svg": "02c3",
	"./xml.svg": "4f75",
	"./zip.svg": "5ceb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ea72";